import React from 'react';
import {Link} from 'react-router-dom';

import {PrimaryButton} from 'Components/Button';

import Authenticated from 'Components/Layouts/Authenticated';

export default class Dashboard extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        return (
            <Authenticated title="Dashboard">
                <h1 className="canela-text text-5xl text-center">
                    Welcome
                </h1>

                <div className="text-center font-light mt-8">
                    <Link to="settings/profile">
                        <PrimaryButton
                            text="Register"
                        />
                    </Link>
                </div>
            </Authenticated>
        );
    }
}
